// ThemeContext.js
import React, { createContext, useEffect, useState } from 'react';
import * as actions from "./store/actions";
import {connect} from "react-redux";

export const ThemeContext = createContext({
  themeValue: ''
});

const ThemeProvider = ({ children, ...props }) => {
  const {restaurantSuccess} = props.restaurantReducer;
  // console.log("restaurantSuccess",restaurantSuccess);
  const [themeValue, setThemeValue] = useState('');
  // console.log("themeValue",themeValue);


  // Dependency array if empty then this useEffect will only run once on mounting

  useEffect(() => {
    fetchTheme();
  },[]);

  useEffect(() => {
    console.log("🏢 ThemeContext - Restaurant Success:", restaurantSuccess);
    if(restaurantSuccess?.data){
      console.log("✅ ThemeContext - Restaurant data loaded:", restaurantSuccess.data.title);
      setThemeValue(restaurantSuccess?.data?.theme);
      if(restaurantSuccess?.data?.default_lang_id)
        // console.log("restaurantSuccess?.datarestaurantSuccess?.datarestaurantSuccess?.data",restaurantSuccess.data)
        localStorage.setItem('language',restaurantSuccess?.data?.default_lang_id);        
        localStorage.setItem('service_fee',restaurantSuccess?.data?.branches[0]?.service_fee);
        localStorage.setItem('vat',restaurantSuccess?.data?.branches[0]?.vat);
    } else {
      console.log("⏳ ThemeContext - Waiting for restaurant data...");
    }
  }, [restaurantSuccess]);

  const fetchTheme = () => {
    // Use actual window location
    const domain = window.location.protocol + "//" + window.location.host;
    console.log("🏢 ThemeContext - Fetching restaurant from domain:", domain);
    props.getRestaurantStart(domain);
    props.getBranchStart();
    
    // For testing specific domain (uncomment to use):
    // const testDomain = 'https://cowboy.ropay.pk';
    // console.log("🔍 Fetching restaurant with domain:", testDomain);
    // props.getRestaurantStart(testDomain);
  };

  return (
    <ThemeContext.Provider value={{ themeValue:themeValue }}>
        {children}
    </ThemeContext.Provider>
  );
};

const mapStateToProps = ({restaurantReducer={}}) => {
  return {restaurantReducer};
};

const mapDispatchToProps = (dispatch) => {
  return {
    getRestaurantStart: (data) => dispatch(actions.getRestaurantData(data)),
    getBranchStart: () => dispatch(actions.getBranchList()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ThemeProvider);
